import { useMemo } from 'react';
import useRangeFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useRangeFilter';
import { createRangeSchema } from '@/creditflowresearch/ui/common/hooks/sidebar/rangeSchema';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';

const usePrice = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();

  const schema = useMemo(() => createRangeSchema({ bounds: filters?.issuePrice }), [filters?.issuePrice]);

  return useRangeFilter({ fromKey: 'includedIssuePriceFrom', toKey: 'includedIssuePriceTo', schema });
};

export default usePrice;
